import React, { useContext, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ProductsContext } from "./Products";
import { defaultDateTimeFormat } from "../../lib/utils";

interface Filters {
    showArchived: boolean;
}

const ProductsTable = (): React.JSX.Element => {
    const { products, setProducts } = useContext(ProductsContext);

    const [filters, setFilters] = useState<Filters>({
        showArchived: false,
    });

    return (
        <>
            <Button
                className="mt-4"
                onClick={() =>
                    setFilters(prev => {
                        return { ...prev, showArchived: !prev.showArchived };
                    })
                }
            >
                {filters.showArchived ? `Hide` : `Show`} Archived Products
            </Button>
            <Table className="productsTable" striped bordered>
                <thead>
                    <tr>
                        <th>Product</th>
                        <th>Price</th>
                        <th>Quantity</th>
                        <th>Active</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Edit</th>
                    </tr>
                </thead>
                <tbody>
                    {products
                        .filter(p => {
                            return filters.showArchived
                                ? true
                                : p.active !== -1;
                        })
                        .map(p => (
                            <tr key={p.id}>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    {p.description}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    ${p.price}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    {p.qty !== null && `${p.qty} / ${p.max}`}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    {p.active === -1
                                        ? "Archived"
                                        : p.active === 1 &&
                                            (p.startDate
                                                ? new Date() >
                                                  new Date(p.startDate)
                                                : true) &&
                                            (p.endDate
                                                ? new Date() <
                                                  new Date(p.endDate)
                                                : true)
                                          ? "Yes"
                                          : "No"}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    {p.startDate &&
                                        `${
                                            defaultDateTimeFormat
                                                .format(new Date(p.startDate))
                                                .split(", ")[0]
                                        }`}
                                    <br />
                                    {p.startDate &&
                                        `${
                                            defaultDateTimeFormat
                                                .format(new Date(p.startDate))
                                                .split(", ")[1]
                                        }`}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    {p.endDate &&
                                        `${
                                            defaultDateTimeFormat
                                                .format(new Date(p.endDate))
                                                .split(", ")[0]
                                        }`}
                                    <br />
                                    {p.endDate &&
                                        `${
                                            defaultDateTimeFormat
                                                .format(new Date(p.endDate))
                                                .split(", ")[1]
                                        }`}
                                </td>
                                <td
                                    className={`${p.active === -1 ? `bg-danger-subtle` : ""}`}
                                >
                                    <Link
                                        to={`/league-management/products/edit/${p.id}`}
                                    >
                                        edit
                                    </Link>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </Table>
        </>
    );
};

export default ProductsTable;
